import { Badge, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material'

import classes from './nav.styles'

const NavList = ({ children }: { children: React.ReactNode | React.ReactNode[] }) => {
  return <List sx={classes.list}>{children}</List>
}

const NavItem = ({
  label,
  icon,
  selected,
  onClick,
  showBadge,
}: {
  label: string
  icon: React.ReactNode
  selected: boolean
  onClick: () => void
  showBadge?: boolean
}) => {
  return (
    <ListItem disablePadding>
      <ListItemButton selected={selected} onClick={onClick} sx={classes.listItemButton}>
        <ListItemIcon color="secondary" sx={classes.listItemIcon}>
          <Badge color="error" variant="dot" invisible={!showBadge} overlap="circular" sx={classes.badge}>
            {icon}
          </Badge>
        </ListItemIcon>

        <ListItemText
          primary={
            <Typography variant="body2" color={selected ? 'secondary.dark' : 'text.secondary'} sx={classes.labelText(selected)}>
              {label}
            </Typography>
          }
        />
      </ListItemButton>
    </ListItem>
  )
}

const Nav = {
  List: NavList,
  Item: NavItem,
}

export default Nav
